var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[_c('input',{ref:"input",staticClass:"single-file-select-input",attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_vm._t("default",null,{"openFileSelect":_vm.openFileSelect})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }